import type { TeamUser } from "../types/teams.types";

export const getUserDisplayName = (user: TeamUser): string => user.name ?? user.email ?? "";
